export default __webpack_public_path__ + "static/media/card_premium_1.2ad8281c.svg";